import posthog from 'posthog-js';
import { PostHogProvider as PHProvider } from 'posthog-js/react';
import { useEffect, ReactNode } from 'react';
import { useAuth } from '@/contexts/AuthContext';

// Check if we are in a browser environment
const isBrowser = typeof window !== 'undefined';

if (isBrowser) {
  const posthogKey = import.meta.env.VITE_POSTHOG_KEY;
  const posthogHost = import.meta.env.VITE_POSTHOG_HOST || 'https://us.i.posthog.com';

  if (posthogKey) {
    posthog.init(posthogKey, {
      api_host: posthogHost,
      person_profiles: 'identified_only', // or 'always' if you want to create profiles for anonymous users as well
      capture_pageview: true,
      capture_pageleave: true,
      persistence: 'localStorage',
      autocapture: true, // Enable autocapture for clicks, inputs, etc.
    });
  } else if (import.meta.env.DEV) {
    console.warn('PostHog API key missing. Analytics will not be sent.');
  }
}

export const PostHogProvider = ({ children }: { children: ReactNode }) => {
  const { user } = useAuth();

  useEffect(() => {
    if (user && isBrowser) {
      // Identify user in PostHog when they log in
      posthog.identify(user.id, {
        email: user.email,
        // Add other user traits if available in your Supabase profile
      });
    } else if (!user && isBrowser) {
      // Reset identification on logout
      posthog.reset();
    }
  }, [user]);

  return <PHProvider client={posthog}>{children}</PHProvider>;
};
